import { Component } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private menu: MenuController,public store: Storage) {}

  async ngOnInit() {
    const storage = new Storage({
        name: '_ionicstorage', storeName: 'leman',
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
      });
      this.store=storage;
        await this.store.create();
  }

  closemenu(){this.menu.close('first');}
  // closemenu2(){this.menu.close('second');}
  refresh() {location.reload();}
  cerrarsesion() {this.menu.close('first'); location.reload();}
  // cerrarsesion2() {this.menu.close('second'); this.store.clear();location.reload();}
}
